import { nodeCategories } from '../constants/nodeCategories';
import type { NodeType, NodeCategory } from '../constants/nodeCategories';

// Map bg color classes to light pastel + text color pairs
const colorMap: Record<string, { bg: string; text: string }> = {
    'bg-blue-500': { bg: 'bg-blue-50', text: 'text-blue-500' },
    'bg-cyan-500': { bg: 'bg-cyan-50', text: 'text-cyan-500' },
    'bg-pink-500': { bg: 'bg-pink-50', text: 'text-pink-500' },
    'bg-indigo-500': { bg: 'bg-indigo-50', text: 'text-indigo-500' },
    'bg-teal-500': { bg: 'bg-teal-50', text: 'text-teal-500' },
    'bg-rose-500': { bg: 'bg-rose-50', text: 'text-rose-500' },
    'bg-amber-500': { bg: 'bg-amber-50', text: 'text-amber-600' },
    'bg-emerald-500': { bg: 'bg-emerald-50', text: 'text-emerald-500' },
    'bg-green-500': { bg: 'bg-green-50', text: 'text-green-500' },
    'bg-violet-500': { bg: 'bg-violet-50', text: 'text-violet-500' },
};

interface NodeTypeModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSelect: (nodeType: NodeType) => void;
    categories?: NodeCategory[];
}

export default function NodeTypeModal({ isOpen, onClose, onSelect, categories }: NodeTypeModalProps) {
    if (!isOpen) return null;

    const handleSelect = (type: NodeType) => {
        onSelect(type);
        onClose();
    };

    return (
        <>
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black/5 z-[60]"
                onClick={onClose}
            />

            {/* Panel */}
            <div className="absolute right-5 top-20 w-[300px] bg-white rounded-xl shadow-xl z-[70] border border-gray-100 overflow-hidden">
                <div className="p-5 space-y-5 max-h-[70vh] overflow-y-auto">
                    {(categories || nodeCategories).map((category, categoryIndex) => (
                        <div key={categoryIndex}>
                            <h3 className="text-[13px] font-bold text-gray-800 mb-2.5">
                                {category.title}
                            </h3>

                            <div className="grid grid-cols-2 gap-2">
                                {category.nodes.map((option) => {
                                    const Icon = option.icon;
                                    const colors = colorMap[option.color] || { bg: 'bg-gray-50', text: 'text-gray-500' };
                                    return (
                                        <button
                                            key={option.type}
                                            onClick={() => handleSelect(option.type)}
                                            className="group flex items-center gap-2.5 rounded-lg px-3 py-2.5 transition-all border border-dashed border-gray-300 hover:border-solid hover:border-[#2196F3] hover:bg-blue-50/40 text-left"
                                        >
                                            <div className={`${colors.bg} w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0`}>
                                                <Icon className={`w-4 h-4 ${colors.text}`} strokeWidth={2} />
                                            </div>
                                            <span className="font-medium text-[12px] text-gray-700 group-hover:text-gray-900 leading-tight">
                                                {option.label}
                                            </span>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
